import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate"
Vue.use(Vuex);

const state={//要设置的全局访问的state对象
	catelist: [],
	imgurl:'http://www.shuanggou.com/sgadmin',
	seotit:'江苏双沟酒业股份有限公司',
	seokey:'双沟,双沟酒业,江苏双沟酒业股份有限公司',
	seodec:'江苏双沟酒业股份有限公司位于中国白酒之都江苏省宿迁市，座落在淮河与洪泽湖环抱的千年古镇——双沟镇。2021年，双沟酒业以199.64亿元的品牌价值荣登“2021中国品牌价值评价信息榜（轻工业）”第9名。',
	//要设置的初始属性值
};
const getters = {   //实时监听state值的变化(最新状态)
    getcatelist(state) {  //方法名随意,主要是来承载变化的值
       return state.catelist
    },
		getimgurl(state){  
		   return state.imgurl
		},
		getseotit(state){
		   return state.seotit
		},
		getseokey(state){
		   return state.seokey
		},
		getseodec(state){
		   return state.seodec
		},
};
const mutations = {
    newcatelist(state,info) {   //自定义改变state初始值的方法，这里面的参数除了state之外还可以再传额外的参数(变量或对象);
        // state.haslogin = true;
				state.catelist = info;
    },
};

const actions = {
    getnewcatelist(context,catelist){    //自定义触发mutations里函数的方法，context与store 实例具有相同方法和属性
        context.commit('newcatelist',catelist)
    },
};
const store = new Vuex.Store({
	state,
	getters,
	mutations,
	actions,
	plugins: [createPersistedState()]
});
		 
export default store;